import { useApplyCertificate } from "@/api/console/certifications/useApplyCertification";
import { Button } from "@/components/ui/button";
import { STATUS } from "@/config/progress";
import toast from "@/lib/toast";
import { useTranslation } from "react-i18next";
import { mutate } from "swr";

interface ApplyCertificateButtonProps {
  id: number;
}

function ApplyCertificateButton({ id }: ApplyCertificateButtonProps) {
  const { t } = useTranslation();

  const { trigger: applyCertificate } = useApplyCertificate(id, {
    onSuccess: (data) => {
      const statues = [
        STATUS.ASSESSMENT_COMPLETED,
        STATUS.RE_ASSESSMENT_COMPLETED,
        STATUS.APPLIED_FOR_CERTIFICATE,
        STATUS.CERTIFICATED_ISSUED,
      ];
      mutate(`/console/assessment_progresses?status=${statues.join(",")}`);
      toast.success(data.message);
    },
  });

  return (
    <Button
      variant="outline"
      onClick={() => {
        toast.loading(t("applying-certificate"));
        applyCertificate();
      }}
    >
      {t("apply-certificate")}
    </Button>
  );
}

export default ApplyCertificateButton;
